import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "drawer", "overlay", "pendingOverlay",
    "ipSlider", "opSlider", "profSlider", "mobSlider",
    "ipLabel", "opLabel", "profLabel", "mobLabel",
    "enable501r", "enableNetwork",
    "filterChip", "providerRows", "filteredCount",
    "providerDetail", "providerChevron"
  ]

  static values = {
    reconfigureUrl: String,
    exportUrl: String
  }

  openDrawer() {
    this.drawerTarget.style.transform = "translateX(0)"
    this.overlayTarget.style.display = "block"
  }

  closeDrawer() {
    this.drawerTarget.style.transform = "translateX(100%)"
    this.overlayTarget.style.display = "none"
  }

  updateSliderLabel(event) {
    const slider = event.target
    const value = slider.value

    if (slider === this.ipSliderTarget) {
      this.ipLabelTarget.textContent = `${value}%`
    } else if (slider === this.opSliderTarget) {
      this.opLabelTarget.textContent = `${value}%`
    } else if (slider === this.profSliderTarget) {
      this.profLabelTarget.textContent = `${value}%`
    } else if (slider === this.mobSliderTarget) {
      this.mobLabelTarget.textContent = `${value}%`
    }
  }

  async applyConfig() {
    this.closeDrawer()

    // Show pending overlay
    if (this.hasPendingOverlayTarget) {
      this.pendingOverlayTarget.style.display = "flex"
    }

    const params = new URLSearchParams({
      inpatient_pct: this.ipSliderTarget.value,
      outpatient_pct: this.opSliderTarget.value,
      professional_pct: this.profSliderTarget.value,
      meet_or_beat_pct: this.mobSliderTarget.value,
      enable_501r: this.enable501rTarget.checked,
      enable_network: this.enableNetworkTarget.checked
    })

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      await fetch(this.reconfigureUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken
        },
        body: params.toString()
      })
    } catch (error) {
      console.error("Reconfigure failed:", error)
      if (this.hasPendingOverlayTarget) {
        this.pendingOverlayTarget.style.display = "none"
      }
    }
  }

  exportCsv() {
    window.location.href = this.exportUrlValue
  }

  toggleProviderRow(event) {
    const row = event.currentTarget
    const detailRow = row.nextElementSibling
    if (!detailRow || !detailRow.dataset.claimsAnalysisTarget?.includes("providerDetail")) return

    const chevron = row.querySelector("[data-claims-analysis-target='providerChevron']")
    const isOpen = detailRow.style.display !== "none"

    if (isOpen) {
      detailRow.style.display = "none"
      if (chevron) chevron.style.transform = ""
    } else {
      detailRow.style.display = ""
      if (chevron) chevron.style.transform = "rotate(90deg)"
    }
  }

  filterProviders(event) {
    const filter = event.params.filter
    const typeMap = {
      "All": null,
      "Hospitals": "Inpatient",
      "Facilities": "Outpatient",
      "Professionals": "Professional"
    }

    // Update chip styles
    this.filterChipTargets.forEach(chip => {
      const chipFilter = chip.dataset.claimsAnalysisFilterParam
      if (chipFilter === filter) {
        chip.style.border = "1px solid #4C56E030"
        chip.style.background = "#4C56E012"
        chip.style.color = "#4C56E0"
      } else {
        chip.style.border = "1px solid #E5E6EA"
        chip.style.background = "transparent"
        chip.style.color = "#717399"
      }
    })

    // Filter rows
    const targetType = typeMap[filter]
    const rows = this.providerRowsTarget.querySelectorAll("tr[data-provider-type]")
    let visibleCount = 0

    rows.forEach(row => {
      const isDetailRow = row.dataset.claimsAnalysisTarget?.includes("providerDetail")
      if (targetType === null || row.dataset.providerType === targetType) {
        // Show main rows; collapse detail rows on filter change
        row.style.display = isDetailRow ? "none" : ""
        if (!isDetailRow) visibleCount++
      } else {
        row.style.display = "none"
      }
    })

    // Reset chevrons on filter change
    this.providerChevronTargets.forEach(c => { c.style.transform = "" })

    if (this.hasFilteredCountTarget) {
      this.filteredCountTarget.textContent = visibleCount
    }
  }
}
